import React, {useEffect, useState} from 'react';
import {Form, Header, Message, Segment, Table} from 'semantic-ui-react';
import {useLoaderData, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {useBlockUI} from 'shared/services/block-ui-service';
import {ToasterConfig} from "../../../../config/ToasterConfig";
import useDriverService from "../../../../services/backoffice/hooks/useDriverService";
import {EditMotoristaRequest} from "../../../../models/requests/edit-motorista-request";
import useFleetService from "../../../../services/backoffice/hooks/useFleetService";
import {ShortDto} from "../../../../models/short-dto";
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import {SessionUser} from "../../../../models/session-user";
import SessionStorage from "../../../../store/session";
import useVehiclePlateService from "../../../../services/backoffice/hooks/useVehiclePlateService";
import PasswordRequirementsHint from "../../../../shared/components/PasswordRequirementsHint";
import { isPasswordPolicyValid } from "../../../../shared/utils/password-policy";

export async function editMotoristaLoader({params}: any) {
    return params.id;
}

const EditMotoristaPage = () => {
    const [motorista, setMotorista] = useState<Partial<EditMotoristaRequest>>();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [passwordError, setPasswordError] = useState<string>('');
    const navigate = useNavigate();
    const loader: any = useLoaderData();
    const [fleets, setFleets] = useState<ShortDto[]>([]);
    const [clients, setClients] = useState<ShortDto[]>([]);
    const {editMotorista, getMotoristaById, changeMotoristaPassword} = useDriverService();
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const {getAllFleetsShortDto} = useFleetService();
    const [vehiclePlates, setVehiclePlates] = useState<ShortDto[]>([])
    const {getAllClientsShortDto} = useClientService();
    const {getAllVehiclePlatesShortDtoFiltered} = useVehiclePlateService();
    const [sessionUser, setSessionUser] = useState<SessionUser>();

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }

        updateSessionUser()
    }, [])
    useEffect(() => {
        const motoristaId = loader;
        if(!motoristaId) return;
        getMotoristaById(motoristaId).then((response: any) => {
            setMotorista(response)
        })
    }, [loader])
    const blockUI = useBlockUI();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        function listFleets() {
            getAllFleetsShortDto().then((response) => {
                setFleets(response);
            })
                .catch(error => {
                })
        }

        listFleets()
    }, [])

    useEffect(() => {
        function listClients() {
            getAllClientsShortDto().then((response) => {
                setClients(response);
            })
                .catch(error => {
                })
        }

        listClients()
    }, [])


    useEffect(() => {
        function ListVehicleplates() {
            getAllVehiclePlatesShortDtoFiltered().then((response) => {
                setVehiclePlates(response);
            })
                .catch(error => {

                })
        }

        ListVehicleplates()
    }, [])

    const changePassword = async () => {
        if (!motorista?.id) return;

        setPasswordError('');

        if (!password || !passwordConfirmation) {
            setPasswordError('Informe a senha e a confirmação');
            toast.warn('Informe a senha e a confirmação', ToasterConfig.error);
            return;
        }

        if (password !== passwordConfirmation) {
            setPasswordError('A senha e a confirmação devem ser iguais');
            toast.warn('A senha e a confirmação devem ser iguais', ToasterConfig.error);
            return;
        }

        if (!isPasswordPolicyValid(password)) {
            setPasswordError('A senha não atende aos requisitos abaixo.');
            toast.warn('A senha não atende aos requisitos abaixo.', ToasterConfig.error);
            return;
        }

        try {
            setLoading(true);
            const result = await changeMotoristaPassword(motorista.id, {
                password,
                passwordConfirmation,
            });
            toast.success(result.message, ToasterConfig.success);
            setPassword('');
            setPasswordConfirmation('');
            setPasswordError('');
        } catch (error: any) {
            const message = error?.response?.data?.errors?.[0]
                ?? error?.response?.data?.message
                ?? 'Falha ao alterar senha do motorista';
            setPasswordError(message);
            toast.warn(message, ToasterConfig.error);
        } finally {
            setLoading(false);
        }
    };

    const updateMotorista = async () => {
        try {
            setLoading(true);
            if (motorista) {
                const result = await editMotorista(motorista, motorista.id);
                if (!!result) {
                    navigate('/backoffice/motoristas/');
                    toast.success('Motorista atualizado com sucesso', ToasterConfig.success);
                }
            }
        } catch (error: any) {
            toast.warn('Falha ao atualizar motorista', ToasterConfig.error);
            setLoading(false);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Motoristas / Editar
            </Header>
            <Form size="large" onSubmit={updateMotorista}>
                <Segment stacked>

                    {sessionUser?.userData?.profile == 'Admin'
                        &&
                        <Form.Select
                            label={'Qual o Cliente do Motorista?'}
                            options={clients}
                            placeholder='Selecione uma opção'
                            value={motorista?.clienteId ?? ''}
                            required
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setMotorista(prevMotorista => ({...prevMotorista, clienteId: selectedValue}));
                            }}
                        />
                    }

                    <Form.Input
                        fluid
                        label="Nome"
                        placeholder="Nome"
                        name="firstName"
                        value={motorista?.firstName}
                        onChange={(event) => setMotorista({...motorista, firstName: event.target.value})}
                    />


                    <Form.Select
                        label={'Placa do motorista (opcional)'}
                        options={vehiclePlates}
                        placeholder='Selecione uma opção'
                        value={motorista?.vehiclePlateId ?? ''}
                        search
                        clearable
                        onChange={(e: any, data: any) => {
                            const selectedValue = data.value;
                            setMotorista(prevPlate => ({...prevPlate, vehiclePlateId: selectedValue}));
                        }}
                    />

                    <Message info size="small">
                        <Message.Header>Premiações diárias</Message.Header>
                        <p>
                            Motoristas sem vínculo com uma frota (operação) não recebem cálculo de premiações diárias.
                            Vincule em Operações → Ver motoristas da frota.
                        </p>
                    </Message>



                    <Table.Row>
                        <Table.HeaderCell>
                            <Form.Button content="Voltar"
                                         icon='arrow left'
                                         onClick={() => navigate('/backoffice/motoristas/')} grey/>
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            <Form.Button content="Atualizar"
                                         type={"submit"}
                                         icon='save'
                                         color={"green"}/>
                        </Table.HeaderCell>
                    </Table.Row>
                    {error && <Message negative>{error}</Message>}
                </Segment>
            </Form>

            {(sessionUser?.userData?.profile === 'Admin' || sessionUser?.userData?.profile === 'Manager') && (
                <Segment stacked>
                    <Header as="h4" color="green">Alterar senha do motorista</Header>
                    <Form>
                        <Form.Input
                            fluid
                            label="Nova senha"
                            type="password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                        />
                        <Form.Input
                            fluid
                            label="Confirmação da senha"
                            type="password"
                            value={passwordConfirmation}
                            onChange={(event) => setPasswordConfirmation(event.target.value)}
                        />
                        <PasswordRequirementsHint password={password} compact />
                        {passwordError && <Message negative size="small">{passwordError}</Message>}
                        <Form.Button
                            type="button"
                            color="orange"
                            icon="key"
                            content="Alterar senha"
                            onClick={changePassword}
                        />
                    </Form>
                </Segment>
            )}
        </div>
    );
};

export default EditMotoristaPage;
